import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetUnApprovedCustomerDetailsModel } from "@tSurya/Services/SurGetCustomPropertiesService";
import { CustomerDetailsDataState } from "@tSurya/Store/Data/SurGetCustomerDetailsState";
import { Draft } from "immer";

const initialState: CustomerDetailsDataState = {
    isLoading: false,
    customerDetailsData: null,
};

const reducer = {
    "Custom/UnApprovedCustomerDetails/BeginLoadCUnApprovedCustomer": (draft: Draft<CustomerDetailsDataState>) => {
        draft.isLoading = true;
    },
    "Custom/UnApprovedCustomerDetails/CompletedLoadUnApprovedCustomer": (
        draft: Draft<CustomerDetailsDataState>,
        action: { result: GetUnApprovedCustomerDetailsModel },
    ) => {
        draft.isLoading = false;
        draft.customerDetailsData = action.result;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
